import React, { useEffect } from 'react'
import { useFormContext } from 'react-hook-form'
import { Divider, Paper } from '@material-ui/core'

import { BannerHeadCard } from '../'
import { CookieCategoryCollapse, CookieStatsCard } from './components'

import useCookieBanner from 'hooks/useCookieBanner'
import useSnackbar from 'hooks/useSnackbar'

import * as service from 'service'
import constants from 'constants/index'

const CookieClassificationCard = () => {
  const { handleSubmit } = useFormContext()
  const snackbar = useSnackbar()

  const { banner, refreshBanner, nextStep, setIsSubmitting, setStepSubmit } =
    useCookieBanner()

  const handleFormSubmit = async (data) => {
    try {
      setIsSubmitting(true)

      if (data.cookies) {
        await service.cookies.cookie.update({
          bannerId: banner?.id,
          cookies: data.cookies,
        })
      }

      snackbar.open({
        variant: 'success',
        message:
          constants.cookies.banner.SUCCESS_MESSAGES[
            constants.cookies.banner.STEPS.CLASSIFICATION
          ],
      })

      await refreshBanner()
      nextStep()
    } catch (error) {
      snackbar.open({
        variant: 'error',
        message: 'Erro ao salvar classificação de cookies. Tente novamente.',
      })
    } finally {
      setIsSubmitting(false)
    }
  }

  // Registra a função de submit no provider quando o componente é montado
  useEffect(() => {
    if (banner) {
      setStepSubmit(() => handleSubmit(handleFormSubmit)())
    }
  }, [setStepSubmit, handleSubmit, banner])

  return (
    <Paper
      variant="outlined"
      id={constants.cookies.banner.COOKIES_BANNER_SETTING_DRIVER_STEP_4}
    >
      <BannerHeadCard name="Categorização de Cookies" />
      <Divider />
      <CookieStatsCard />
      <CookieCategoryCollapse />
    </Paper>
  )
}

export default CookieClassificationCard
